<template>
  <div class="component component--fullscreen" v-if="visable">
    <transition name="overlay">
      <div class="component__overlay" v-if="componentVisible"></div>
    </transition>
    <transition name="modal">
      <div class="component__containter" v-if="componentVisible" ref="containter">
        <div class="cellphone-barcode">
          <div class="cellphone-barcode__header">
            <div class="placeholder"></div>
            <div class="title">{{ $t('index.Einvoice') }}</div>
            <button class="close" v-on:click="toggleModal()"><i class="material-icons">close</i></button>
          </div>
          <div class="cellphone-barcode__body">
            <div class="panel">
              <div class="container">
                <div class="row no-gutters justify-content-center">
                  <div class="col">
                    <div class="panel-body">
                      <div class="row no-gutters">
                        <div class="col">
                          <div class="o-form__row">
                            <div class="o-form__icon">
                              <i class="material-icons">receipt</i>
                            </div>
                            <div class="o-form__content">
                              <div class="o-form__label">
                                {{ $t('index.Einvoice') }}
                              </div>
                              <div class="o-form__value">
                                <input
                                  type="text"
                                  class="o-form__input"
                                  :placeholder="$t('index.EinvoicePlaceholder')"
                                  v-model.trim="barcode"
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="panel-footer">
                      <div class="row narrow-gutters">
                        <div class="col">
                          <button
                            class="btn btn-lg btn-block"
                            :class="{ 'btn-loading': isLoading }"
                            :disabled="isLoading"
                            v-on:click="submit()"
                          >
                            {{ $t('common.submit') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import swal from 'sweetalert2';
import Axios from '@/helpers/axios';

export default {
  name: 'Cellphone-Barcode',
  props: {
    visable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      componentVisible: true,
      barcode: null,
      isLoading: false,
    };
  },
  computed: {
    ...mapState([
      'client',
      'card',
    ]),
  },
  methods: {
    toggleModal() {
      this.$emit('toggleModal');
    },
    submit() {
      if (!this.barcode) {
        this.$root.$message.error(this.$i18n.t('index.cellphoneBarcodeEmpty'));
        return;
      }
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      const cellphoneBarcodePattern = /[/][A-Z0-9.\-+]{7}/g;

      if (cellphoneBarcodePattern.exec(this.barcode) === null) {
        this.$root.$message.error(this.$i18n.t('index.invalidCellphoneBarcodeEmpty'));
        return;
      }

      const data = {
        ...this.$route.query,
        lang: this.$i18n.locale,
        p: this.client.phoneType,
        brand_id: this.$route.params.brand,
        dtk: this.client.dtk,
        einvoice_barcode: this.barcode,
      };

      Axios({
        method: 'post',
        url: '/User/UpdateUser',
        data,
      })
        .then((response) => {
          if (response.data.code === 500) {
            swal.fire({
              text: this.$i18n.t('index.cellphoneBarcodeSuccess'),
              confirmButtonText: this.$i18n.t('common.ok'),
            })
              .then(() => {
                window.location.reload(false);
              });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    visable(value) {
      this.$nextTick(() => {
        this.componentVisible = value;
        if (this.card.einvoiceBarcode != null) {
          this.barcode = this.card.einvoiceBarcode;
        }
      });
    },
  },
};
</script>

<style lang="sass" scoped>
@import '../../../assets/sass/compoments/o-panel.sass'
@import '../../../assets/sass/compoments/o-form.sass'

.component--fullscreen
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1040

  transition: all .25s ease

.component__overlay
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1040
  opacity: .7

  background-image: linear-gradient(0deg, rgba(44,43,43,0.95) 0%, rgba(33,32,32,0.95) 100%)

.component__containter
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1050
  margin: 0 auto
  overflow: auto
  display: flex
  flex-direction: column-reverse
  -webkit-overflow-scrolling: touch

  @media only screen and (min-width : 768px)
    max-width: 500px

.cellphone-barcode
  padding: 12px 16px

  border-radius: 16px 16px 0 0

  background-color: white

  &__header
    display: flex
    align-items: center

    .title
      flex-grow: 1

      font-weight: bold
      text-align: center

    .placeholder
      width: 40px
      height: 40px

    .close
      padding: 8px
      width: 40px
      height: 40px

      border: none
      border-radius: 12px

      background-color: #F1F1F1

      color: #909090

      outline: none

      &:active
        color: #333

  &__body
    .container
      padding-left: 0
      padding-right: 0

    .panel
      text-align: left
      padding-top: 0

      &-body
        margin: 0

    .o-form__input
      max-width: 100%

.overlay-enter-active,
.overlay-leave-active
  transition: opacity .25s cubic-bezier(.4, 0, .2, 1)

.overlay-enter,
.overlay-leave-to
  opacity: 0

.modal-enter-active,
.modal-leave-active
  transition: opacity .25s cubic-bezier(.4, 0, .2, 1), transform .15s cubic-bezier(.4, 0, .2, 1)

.modal-enter,
.modal-leave-to
  opacity: 0
  transform: translateY(100%)
</style>
